<template>
  <div class="pravo__top">
    <div class="pravo__top__nadpis">
      <div class="pravo__top__nadpis__image">
        <div :class="Image"></div>
      </div>

      <div class="pravo__top__nadpis__text">{{ Header }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PravoTop",
  props: {
    Image: String,
    Header: String,
  },
};
</script>